<template>
  <ul class="ulBox" ref="ulBox"
      infinite-scroll-distance="0" infinite-scroll-immediate-check="false"
      v-infinite-scroll="loadMore" infinite-scroll-disabled="moreLoading">
    <li v-for="(item,index) in shareArr">
      <div class="list">
        <!--<i :class="[sliceType(item.fileName, item.isDir, item.shareStatus)]"></i>-->
        <span :class="styleObject(item.fileName,item.isDir,item.fileCategory)"
              v-if="sliceType(item.fileName,item.isDir,item.fileCategory)!=='package'">
               <i :class="classObject(item.fileName,item.isDir,item.fileCategory)"
                  class="iconfont"></i>
          </span>
        <svg class="icon" aria-hidden="true" v-else>
          <use xlink:href="#icon-package"></use>
        </svg>
        <div class="con">
          <div class="right">
            <h3>{{delateFile(item.fileName, item.shareStatus)}}</h3>
            <span>{{formaTime(item.gmtCreate)}}</span>
          </div>
          <div class="size">{{expire(item.remainDays)}}</div>
          <div class="morea" @click="selected(index,item.shareUrl)" :class="{'more':up===index}"
               v-show="item.shareStatus!==-1"></div>
        </div>
      </div>
      <div class="select" v-show="select===index">
        <ul>
          <li>
            <i class="icon-fuzhidao iconfont" style="font-size: .48rem;display: block;color: #999;"></i>
            <p><span @click="cancelShare(item.id)">取消分享</span></p>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>
<script>
  import apis from '../../apis/index'
  import Clipboard from 'clipboard'
  import {Toast} from 'mint-ui'
  import cloudApi from '../../apis/cloudStorageApi'
  import Vue from 'vue'

  export default {
    data () {
      return {
        shareArr: [],
        info: {
          page: 0,
          size: 20
        },
        page: 0,
        size: 20,
        totalPages: '',
        shareUrl: '',
        domin: '',
        select: '',
        up: ''
      }
    },

    methods: {
      classObject (val, val2, val3) {
        let type = this.sliceType(val, val2, val3)
        return 'icon-' + type
      },
      styleObject (val, val2, val3) {
        let type = this.sliceType(val, val2, val3)
        if (type === 'excel') {
          return 'excel'
        } else if (type === 'pdf') {
          return 'pdf'
        } else if (type === 'word') {
          return 'word'
        } else if (type === 'txt') {
          return 'txt'
        } else if (type === 'pic') {
          return 'pic'
        } else if (type === 'muisc') {
          return 'muisc'
        } else if (type === 'dir') {
          return 'dir'
        } else if (type === 'html') {
          return 'html'
        } else if (type === 'shareDir') {
          return 'shareDir1'
        } else {
          return 'weizhi'
        }
      },
      expire: function (time) {
        if (!time) {
          return '永久有效'
        } else {
          return time + '天后到期'
        }
      },
      delateFile: function (val, statu) {
        if (statu === -1) {
          return '分享的文件已被删除'
        } else {
          return val
        }
      },
      formaTime: (val) => {
        if (val !== '' || undefined || null) {
          return new Date(val).format('yyyy-MM-dd HH:mm')
        }
      },
      sliceType: function (val, num, flag) {
        if (num === 1) {
          if (flag === 2) {
            return 'shareDir'
          } else {
            return 'dir'
          }
        }
        if (val) {
          var point = val.lastIndexOf('.')
          var type = val.substring(point + 1).toLowerCase()
          if (type === 'jpg' || type === 'gif' || type === 'JPG' || type === 'GIF' || type === 'png' || type === 'JPEG' || type === 'jpeg') {
            return 'pic'
          } else if (type === 'avi' || type === 'rmvb' || type === 'rm' || type === 'asf' || type === 'divx' || type === 'mpg' || type === 'mpeg' || type === 'mpe' || type === 'mp4' || type === 'mkv' || type === 'vob ') {
            return 'video'
          } else if (type === 'WAVE' || type === 'AIFF' || type === 'MPEG' || type === 'MP3' || type === 'MIDI' || type === 'mp3') {
            return 'muisc'
          } else if (num === 1) {
            return 'dir'
          } else if (type === 'txt') {
            return 'txt'
          } else if (type === 'pdf') {
            return 'pdf'
          } else if (type === 'doc' || type === 'docx') {
            return 'word'
          } else if (type === 'ppt' || type === 'pptx') {
            return 'ppt'
          } else if (type === 'xls' || type === 'xlsx') {
            return 'excel'
          } else if (type === 'html' || type === 'htm') {
            return 'html'
          } else if (type === 'wps' || type === 'wpt') {
            return 'wps'
          } else if (type === 'zip' || type === 'rar') {
            return 'package'
          } else {
            return 'default'
          }
        }
      },
      bytesToSize: function (bytes) {
        if (bytes === 0) return '0 B'
        if (bytes === '') return ''
        var k = 1024
        var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        var i = Math.floor(Math.log(bytes) / Math.log(k))
        return (bytes / Math.pow(k, i)).toPrecision(3) + sizes[i]
      },
      selected: function (index, shareUrl) {
        let _this = this
        if (this.select === index) {
          this.select = ''
          this.up = ''
        } else {
          this.select = index
          this.up = index
        }
      },
      load: function () {
        apis.request(cloudApi.shareOther, this.info).then(response => {
          let data = response.data.content
          if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              this.shareArr.push(data[i])
            }
            this.totalPages = response.data.totalPages
          }
          return false
        }).catch(function (error) {
        })
      },
      loadMore () {
        this.loading = true
        setTimeout(() => {
          let _this = this
          if (_this.page < _this.totalPages) {
            _this.page++
          }
          apis.request(cloudApi.shareOther, {page: _this.page, size: _this.size}).then(function (res) {
            let list0 = []
            let data = res.data.content
            if (data.length > 0) {
              for (var i = 0; i < data.length; i++) {
                list0.push(data[i])
              }
              if (_this.shareArr && list0) {
                _this.shareArr = _this.shareArr.concat(list0)
              }
            }
          })
          this.loading = false
        }, 250)
      },
      cancelShare (id) {
        apis.request(cloudApi.cancelShareWorkmate, {assignedShareIds: id}).then(() => {
          this.select = ''
          this.up = ''
          this.shareArr.forEach((value, index, array) => {
            if (value.id === id) {
              array.splice(index, 1)
            }
          })
          Toast({
            message: '取消分享成功',
            iconClass: 'icon-success'
          })
        })
      }
    },
    created () {
      this.load()
    }
  }
</script>
<style scoped>
  .iconfont {
    font-size: 0.62rem;
  }

  html {
    overflow: scroll !important;
  }

  .icon-success {
    background: url("../../assets/images/success_icon.png");
  }

  .icon-default, .icon-undefined {
    color: #dadcdd;
  }

  body {
    font-size: 0.16rem !important;
  }

  #myShare {
    height: 100%;
    padding-top: 1.28rem;
  }

  #myShare .head ul input {
    height: 0.4rem;
    font-size: 0.28rem;
    margin-top: 0.23rem;
    width: 1.12rem;
    text-align: right;
  }

  #myShare .head ul input:first-of-type {
    text-align: left;
  }

  input {
    font-size: 0.16rem;
  }

  input:focus {
    outline: none;
  }

  .check-mobile {
    background: url("../../assets/images/check-mobile.png") center no-repeat;
    background-size: 0.36rem 0.36rem;
  }

  .open-mobile {
    background: url("../../assets/images/open-mobile.png") center no-repeat;
    background-size: 0.36rem 0.36rem;
  }

  .right {
    /*margin-left: 1rem;*/
  }

  .right h3 {
    width: 3rem;
    /*height: 0.4rem;*/
    /*overflow: hidden;*/
    /*text-overflow: ellipsis;*/
    /*white-space: nowrap;*/
    word-break: break-all;
    font-size: 0.28rem;
    color: #1d1f22;
  }

  .right span {
    font-size: 0.18rem;
    color: #9b9b9b;
  }

  h1, h2, h3 {
    font-weight: normal;
    margin: 0;
    line-height: initial;
  }

  h3 {
    text-align: left;
  }

  /*顶部样式*/
  .head {
    font-size: 0.36rem !important;
    position: fixed;
    top: 0;
    width: 100%;
    height: 1.28rem;
    line-height: 0.88rem;
    -webkit-backdrop-filter: blur(40px);
    backdrop-filter: blur(40px);
    background-color: #E4393C;
    color: #fff;
    z-index: 999;
    padding: 0 0.3rem;
  }

  .head ul {
    text-align: center;
    position: relative;
    margin-top: 0.4rem;
  }

  #head ul li:nth-of-type(n+2) {
    float: right;
    width: 0.36rem;
    height: 0.36rem;
    /*background-color: #fff;*/
    position: absolute;
    right: 0;
    top: 0.25rem;
  }

  #head ul li:last-of-type {
    right: 0.66rem;
  }

  /*无内容时样式*/
  .jpg {
    position: relative;
    height: 100%;
  }

  .jpg div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .jpg div p {
    font-size: 0.28rem;
    color: #41464c;
  }

  /*有内容时的样式*/
  .ulBox {
    height: calc(100vh - 2.5rem);
    overflow-y: scroll;
    background-color: #fff;
  }

  .list {
    padding-left: 0.3rem;
    width: 80%;
  }

  /*点击下啦*/
  .select {
    height: 0.98rem;
    background-color: #f7f7fa;
    /*line-height: 0.98rem;*/
    text-align: center;
    color: #333;
  }

  .select ul {
    height: 100%;
    /*padding-top: 0.2rem;*/
    padding: .1rem 0;
    color: #333333;
    background-color: #f7f7f7;
    font-size: 0.2rem;
  }

  .select ul li {
    float: left;
    height: 100%;
    /*width: 25%;*/
    width: 100%;
    border: none;
    text-align: center;
  }

  .hselect ul li {
    width: 50%;
  }

  .hselect ul li:first-child {
    display: none;
  }

  .select ul li img {
    float: initial;
    width: 0.35rem;
    height: 0.36rem;
  }

  .btn {
    background-color: rgba(0, 0, 0, 0);
    border: 0;
    color: #fff;
  }

  .con {
    display: inline-block;
    width: 70%;
    margin-left: 0.228rem;
  }

  .con .size {
    position: absolute;
    right: 0.64rem;
    top: 0.4rem;
  }

  #moreh {
    width: 0.2rem;
    height: 0.26rem;
    position: absolute;
    right: 0.2rem;
    top: 0.4rem;
    background: url("../../assets/images/down.png") center no-repeat;
    background-size: 0.18rem 0.12rem;
  }

  .morea {
    width: 0.2rem;
    height: 0.26rem;
    position: absolute;
    right: 0.2rem;
    top: 0.4rem;
    background: url("../../assets/images/down.png") center no-repeat;
    background-size: 0.18rem 0.12rem;
  }

  .more {
    background: url("../../assets/images/up.png") center no-repeat !important;
    background-size: 0.18rem 0.12rem !important;
  }

  .ulBox li {
    border-bottom: 1px solid #e5e5e5;
    text-align: left;
    position: relative;
  }

  .ulBox li div:first-of-type {
    box-sizing: border-box;
  }

  .ulBox .list {
    /*height: 0.99rem;*/
    display: flex;
    padding-top: 0.14rem;
  }

  .ulBox li img {
    float: left;
    width: 0.5rem;
    height: 0.5rem;
    display: inline-block;
  }

  .check {
    width: 0.24rem;
    height: 0.24rem;
    border: 1px solid #979797;
    display: inline-block;
    border-radius: 50%;
    /*float: left;*/
    margin-bottom: 0.12rem;
    margin-right: 0.3rem;
  }

  .checked {
    background: url('../../assets/images/success_big.png') center no-repeat;
    background-size: 0.24rem 0.24rem;
    border: none;
  }

  /*分享样式*/
  .mint-actionsheet {
    position: fixed;
    background: #e0e0e0;
    width: 100%;
    text-align: center;
    bottom: 0;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    backface-visibility: hidden;
    transition: transform .3s ease-out;
  }

  .mint-actionsheet-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .mint-actionsheet-listitem {
    border-bottom: solid 1px #e0e0e0;
  }

  .mint-actionsheet-listitem span {
    width: 49%;
    height: 100%;
    display: inline-block;
  }

  .mint-actionsheet-listitem span:first-of-type {
    border-right: 1px solid #e0e0e0;
  }

  .mint-actionsheet-button {
    display: block;
    width: 100%;
    height: 45px;
    line-height: 45px;
    font-size: 18px;
    color: #333;
    background-color: #fff;
  }

  .mint-actionsheet-button:active {
    background-color: #f0f0f0;

  }

  .v-model {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: .5;
    background: #000;
  }

  .actionsheet-float-enter,
  .actionsheet-float-leave-active {
    transform: translate3d(-50%, 100%, 0);
  }

  .sharetime {
    height: 1.46rem !important;
    font-size: 0.3rem !important;
  }

  .shareTip {
    height: 0.65rem !important;
    font-size: 0.3rem !important;
    color: #888 !important;
    text-align: left;
    line-height: 0.65rem;
    padding-left: 0.3rem;
  }

  .isClip {
    opacity: 0.6;
  }

  .period {
    height: 0.81rem !important;
    line-height: 0.81rem;
  }

  .period .aging {
    width: 0.24rem;
    height: 0.24rem;
    border: 1px solid #979797;
    display: inline-block;
    border-radius: 50%;
    margin-right: 5px;
  }

  .period .checked {
    background: url('../../assets/images/success_big.png') center no-repeat;
    background-size: 0.24rem 0.24rem;
  }

  .period li {
    width: 33.333%;
    height: 100%;
  }

  @keyframes move {
    from {
      top: 800px;
    }
    to {
      top: 0;
    }
  }

  .copy {
    height: 100%;
    width: 100%;
    top: 0px;
    /*position: absolute;*/
    /*background-color: red;*/
  }

  .move {
    animation: move 5s;
  }

  .copy-bottom {
    line-height: 0.98rem;
    position: fixed;
    width: 100%;
    bottom: 0;
    height: 0.98rem;
    background-color: #3f4b5f;
    padding: 0 0.1rem;
  }

  .copy-bottom input {
    width: 3.6rem;
    height: 0.68rem;
    border-radius: 10px;
    background-color: #7b8ca9;
    color: #fff;
    font-size: 0.28rem;
  }

  .copy-bottom input:last-of-type {
    background-color: #E4393C;
  }

  .copyhello {
    padding-top: 1.48rem;
  }

  .tip {
    height: 0.6rem;
    line-height: 0.6rem;
    background-color: #f7f7fa;
    color: #666;
    font-size: 0.24rem;
    padding-left: 0.3rem;
  }

  #copy {
    padding: 0 2rem;
    position: relative;
  }

  #copy .back {
    position: absolute;
    left: 0.3rem;
  }

  #copy li {
    float: left;
    position: initial;
    width: 50%;
  }

  #copy .list {
    width: 100%;
  }

  #cancel {
    position: absolute;
    right: 0.3rem;
    font-size: 0.28rem;
  }

  .pb {
    padding-bottom: 0;
  }

  .bp {
    padding-bottom: 0.98rem;
  }

  .shareTarget {
    opacity: 0.6;
  }

  .history {
    height: 100%;
  }

  .history .head {
    padding: 0 0.3rem;
  }

  .history ul {
    position: relative;
  }

  .history .head input {
    height: 0.4rem;
    font-size: 0.28rem;
    margin-top: 0.23rem;
    width: 1.12rem;
    text-align: right;
  }

  .history .head input:first-of-type {
    text-align: left;
  }

  #check-history {
    width: 0.36rem;
    height: 0.36rem;
    position: absolute;
    right: 0;
    top: 0.25rem;
  }

  #his {
    background-color: #3f4b5f;
    line-height: 0.98rem;
    color: #fff;
  }

  #his a {
    opacity: 0.3;
  }

  #his .box {
    opacity: 0.3;
    color: #fff;
  }

  .his a {
    opacity: 1 !important;
  }

  #his .box img {
    width: 0.34rem;
    height: 0.36rem;
  }

  .begin .head ul input {
    height: 0.4rem;
    font-size: 0.28rem;
    margin-top: 0.23rem;
    width: 1.12rem;
    text-align: right;
  }

  .begin .head ul input:first-of-type {
    text-align: left;
  }

  .begin .head {
    padding: 0 0.3rem;
  }

  .back {
    width: 0.2rem;
    height: 0.35rem;
    background: url("../../assets/images/back-mobile.png") center no-repeat;
    background-size: 0.2rem 0.35rem;
    top: 0.26rem;
    position: absolute;
    left: 0;
  }

  #selectDown {
    top: 0;
    height: 1.42rem;
    position: fixed;
    width: 100%;
    text-align: center;
    left: 0;
    backface-visibility: hidden;
    transform: translate3d(0px, 0px, 0px);
    transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;
    background-color: #fff;
    padding: 0.34rem 0 0.24rem 0;
  }

  #selectDown div {
    width: 50%;
    float: left;
    color: #1d1f22 !important;
    text-align: center;
    font-size: 0.24rem;
    height: 100%;
    line-height: initial;
  }

  #selectDown div input {
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
  }

  #selectDown div img {
    display: block;
    margin: 0 auto;
    width: 0.48rem;
    height: 0.4rem;
    margin-bottom: 0.1rem;
  }

  #selectDown div:first-of-type {
    border-right: 1px solid #eee;
  }

  .pullUp {
    transform: translate3d(0px, 0.88rem, 0px) !important;
  }

  .shareDir1 {
    color: #47A3FB;
  }
</style>



// WEBPACK FOOTER //
// src/views/myShare/workmateShare.vue